// import projectsData from "@/data/projects.json";
import projectsData from '@/data/projects-alpha.json';

import { Project } from '@/utils/types';

export const runBaseQl = async (graphql: string) => {
  return await fetch(
    'https://api.baseql.com/airtable/graphql/appvVxGvGLCrdiCZM',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${process.env.BASEQL_KEY}`,
      },
      body: JSON.stringify({
        query: graphql,
      }),
    },
  )
    .then(r => {
      try {
        return r.json();
      } catch (e) {
        console.log('error with response 1', r);
      }
    })
    .catch(e => {
      console.log('error with response 2', e);
    });
};

export const getProjects2 = async () => {
  return await fetch(`${process.env.SILO_API_URL}`, {
    headers: {
      'X-SILO-KEY': `${process.env.SILO_KEY}`,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })
    .then(res => {
      try {
        return res.json();
      } catch (e) {
        console.log('error with response 1', res);
      }
    })
    .catch(error => {
      console.error('There was an error with the request:', error);
    });
};

export const getProjects = async (): Promise<Project[]> => {
  return projectsData as Project[]; // Explicitly cast the imported JSON data
};

export const getUniqueServices = async () => {
  const posts = await getProjects(); // Resolving the Promise to get posts array
  const uniqueServices = [
    ...new Set(posts.flatMap(post => post.services)), // Now we can safely use flatMap
  ];
  console.log(uniqueServices); // Logs unique tags
};
